module.exports = __webpack_public_path__ + "img/img_page_02_01.6a8ba3f8.png";